<template>
	<div>
		<MessageDialog
			:patient-list="selectedPatient"
			:show-message="newMessageDialog"
			@remove-patient="removePatient"
			@close="newMessageDialog = false"></MessageDialog>
		<ProgressBar colorType="engagement" v-if="isLoading"></ProgressBar>
		<div class="sub-head">
			<router-link :to="`/engagement/${$route.params.profileId}`">
				<i class="el-icon-back"></i>
			</router-link>
			<div class="sub-title">
				{{$route.params.eventId.replace('v0_', '').replace($route.params.profileId, '').replace(/-/g, ' ')}}
			</div>
			<span class="dot"></span>
		</div>
		<div class="event-detail-body">
			<ActionStatus :patientNo="patientData.length"
				:action="$route.query.status"
				:messageName="compareMessageName"
				></ActionStatus>
			<div class="select-patient" v-if="selectedPatient.length > 0">
				<span>{{selectedPatient.length}} patient{{selectedPatient.length > 1 ? 's': ''}} selected</span>
				<el-button class="message-button" @click="newMessageDialog = !newMessageDialog">Send Message</el-button>
			</div>
			<PatientTable style="margin-top: 10px"
				:message-list="messageList"
				:patient-data="patientData"
				@selected="onSelectPatient"
				:compare="$route.params.messageId"></PatientTable>
		</div>

	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import EventMixin from './event/mixin'

import PatientTable from './common/PatientTable'
import MessageDialog from './common/MessageDialog'
import ActionStatus from './common/ActionStatus'
import ProgressBar from '@/module/component/ProgressBar'

export default {
	name: 'message-detail',
	data() {
		let dateRange = [
			this.$route.query.start ? new Date(parseInt(this.$route.query.start)) : null,
			this.$route.query.end ? new Date(parseInt(this.$route.query.end)) : null
		]
		return {
			event: {
				id: this.$route.params.eventId,
			},
			selectedPatient: [],
			newMessageDialog: false,
			dateRange
		}
	},
	created() {
		this.loadEventData({
				event: this.event.id,
				start: this.dateRange[0] ? this.dateRange[0].setHours(0,0,0,0) : null,
				end: this.dateRange[1] ? this.dateRange[1].setHours(0,0,0,0) : null
			})
	},
	methods: {
		...mapActions('engagement', ['loadEventData']),
		onSelectPatient(selectedPatient) {
			this.selectedPatient = selectedPatient.map(id => {
				return {
					id,
					name: this.patientData.find(patient => id === patient.id).given_name
				}

			})
		},
		removePatient(patientId) {
			this.selectedPatient =  this.selectedPatient.filter(patient => patientId !== patient.id)
		},
		showPatientStatus(patient) {
			const status = this.$route.query.status
			let messageList = this.messageList
			if(this.$route.params.messageId)
				messageList = this.messageList.filter(message => message.id === this.$route.params.messageId)
			if(status === 'all') {
				return true
			}
			else if(status === 'noaction') {
				return messageList.every(message => {
					return patient[message.id].every(action => this.isEmptyObject(action))
				})
			}

			else {
				return messageList.some(message => {
					return patient[message.id].some(action => {
						if(status === 'gotit') return action.hasOwnProperty('accepted')
						else if(status === 'learnmore') return action.hasOwnProperty('action')
						else return action.hasOwnProperty(status)
					})
				})
			}
		}
	},
	computed: {
		...mapState('engagement', {
			isLoading (state) {
				return state.loading[this.event.id]
			}
		}),
		...mapGetters('engagement', ['getPatientData', 'getMessageList']),
		messageList() {
			return this.getMessageList(this.event)
		},
		patientData() {
			return this.getPatientData(this.event).filter(patient => this.showPatientStatus(patient))
		},
		compareMessageName() {
			const compareMessage = this.messageList.find(message => message.id === this.$route.params.messageId)
			console.log(compareMessage)
			return compareMessage ? compareMessage.delayTitle + ' ' + compareMessage.title : ''
		}
	},
	components: {
		PatientTable,
		MessageDialog,
		ActionStatus,
		ProgressBar
	},
	mixins: [EventMixin]
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
.select-patient{
	margin-top: 10px;
}
</style>
